import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsService } from 'src/app/common/services/utils.service';
import { Event } from 'src/app/common/events/event-base';
import { BaseSearchResultsComponent } from '../base-search-results/base-search-results.component';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TruncatePipe } from 'src/app/common/pipes/truncate.pipe';


@Component({
  selector: 'gig-backlinks-results',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, TooltipModule, TranslateModule, TruncatePipe],
  templateUrl: './backlinks-results.component.html',
  styleUrls: ['./backlinks-results.component.scss']
})
export class BacklinksResultsComponent extends BaseSearchResultsComponent implements OnInit {

  public selectedBacklink: any;
  public selectedResults: Array<any>;
  public cols: Array<any>;

  @Output() pageChanged: EventEmitter<BacklinksResultsEvent> = new EventEmitter<BacklinksResultsEvent>();
  @Input() searchResults: Array<any>;

  constructor(public utils: UtilsService, @Optional() public config: DynamicDialogConfig) {
    super(utils);
  }

  public ngOnInit(): void {
    this.applyDialogData();

    this.cols = [
      {field: 'referringPage', header: 'Referring Page'},
      {field: 'rank', header: 'Rank'},
      {field: 'externalLinks', header: 'External Links'},
      {field: 'new', header: 'New'},
      {field: 'broken', header: 'Broken'},
      {field: 'anchor', header: 'Anchor'},
      {field: 'firstSeen', header: 'First Seen'}
    ];
  }

  public onPageChanged(e: any): void {
    this.utils.logger.info('BacklinksResultsComponent.onPageChanged() ');
    this.pageChanged.emit(new BacklinksResultsEvent('BacklinksResultsComponent.PAGE_CHANGED', e));
  }

  public onSelectedBacklinkClicked(e: any): void {

  }

  private applyDialogData(): void {
    if (this.config?.data) {
      this.searchResults = this.config.data;
    }
  }


  get getSelectedSearchResults(): Array<any> {
    return this.selectedResults;
  }

}

export class BacklinksResultsEvent extends Event {
  constructor(type: string, payload: any) {
    super(type, payload);
  }
}